import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Card, Col, Container, Row } from 'react-bootstrap';

import ResetPassword from '../../components/auth/ResetPassword';
import { Link } from 'react-router-dom';

import maskIcon5 from '../../assets/img/new/dashboard-1.png';
import maskIcon6 from '../../assets/img/new/dashboard-2.png';
import appLogo from '../../assets/img/new/disputelylogonew2-139.svg';

const SignInPage = () => (
  <React.Fragment>
    <Helmet title='Reset Password' />
    <style>
      {`
  #showPass .btn:hover {
	color: var(--bs-btn-hover-bg);
	background-color: white;

}
  `}
    </style>
    <Row className='h-100'>
      <Col lg='6' id='leftside' className='p-5' style={{ backgroundColor: '#ebf4ff' }}>
        <Container>
          <img className='disputely-logo-new-2-1-icon40 mb-5' alt='' src={appLogo} />
          <div className='w-65 d-flex flex-column mx-auto'>
            <img className='img-fluid me-5 mb-5 shadow' alt='' src={maskIcon5} />
            <img className='img-fluid ms-5 shadow' alt='' src={maskIcon6} />
          </div>
        </Container>
      </Col>
      <Col lg='6' id='rightside' className='col-lg-6'>
        <div id='signup' className='col-lg-6 m-auto d-flex flex-column' style={{ paddingTop: '20%' }}>
          <h3 className='text-dark-blue mb-4'>Reset Your Password</h3>
          <ResetPassword />
          <Col lg='12'>
            <p className='text-center mt-5'>
              Remeber Password?{' '}
              <Link to='/' className='text-decoration-none'>
                Login
              </Link>
            </p>
          </Col>
        </div>
      </Col>
    </Row>
  </React.Fragment>
);

export default SignInPage;
